module.exports = __webpack_public_path__ + "static/images/containers/Landing/components/LandingClans/components/Card/components/Front/images/corner.5f857dda.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingClans/components/Card/components/Front/images/corner.png
// module id = 3123
// module chunks = 11